import React from 'react';

// Routes
import Routes from './training-proposal-routes';

export default function (props) {

  return (
   <div>
       <Routes />
   </div>
  )
}
